import * as React from 'react'
import { Chip, IconButton, Tooltip } from '@mui/material'
import StarIcon from '@mui/icons-material/Star'
import StarBorderIcon from '@mui/icons-material/StarBorder'
import DeleteOutlineIcon from '@mui/icons-material/DeleteOutline'
import TuneOutlinedIcon from '@mui/icons-material/TuneOutlined'
import { ASSIGNMENT_ACCESS_MODE, TREE_PERMISSION } from '../../../utils/treePermissions'

// Permisos por asignación: campo de la API, cabecera de columna y etiqueta del checkbox.
export const PERMISSION_OPTIONS = [
  { permission: TREE_PERMISSION.REGISTER, headerName: 'Registrar', label: 'Registrar árboles' },
  { permission: TREE_PERMISSION.UPDATE, headerName: 'Actualizar', label: 'Actualizar árboles' },
]

const EDIT_PERMISSIONS_TOOLTIPS = {
  [ASSIGNMENT_ACCESS_MODE.FLAGS]: 'Editar permisos',
  [ASSIGNMENT_ACCESS_MODE.READ_ONLY]: 'Visitante: solo lectura',
  [ASSIGNMENT_ACCESS_MODE.TOTAL]: 'Administrador: acceso total',
  [ASSIGNMENT_ACCESS_MODE.NONE]: 'Rol sin permisos de escritura',
}

// El rol manda sobre el flag guardado: admin, acceso total; visitante, solo lectura.
const renderPermissionCell = params => {
  switch (params.row.accessMode) {
    case ASSIGNMENT_ACCESS_MODE.TOTAL:
      return <Chip label="Total" color="primary" size="small" variant="outlined" />
    case ASSIGNMENT_ACCESS_MODE.READ_ONLY:
      return <Chip label="Solo lectura" size="small" variant="outlined" />
    case ASSIGNMENT_ACCESS_MODE.NONE:
      return '—'
    default:
      return params.value === true ? (
        <Chip label="Sí" color="success" size="small" />
      ) : (
        <Chip label="No" size="small" variant="outlined" />
      )
  }
}

export const permissionColumns = PERMISSION_OPTIONS.map(({ permission, headerName }) => ({
  field: permission,
  headerName,
  headerAlign: 'center',
  align: 'center',
  flex: 1,
  minWidth: 100,
  renderCell: renderPermissionCell,
}))

export const getColumns = (onSetPrimary, onDelete, onEditPermissions) => [
  {
    field: 'tenantName',
    headerName: 'Tenant',
    headerAlign: 'center',
    flex: 2,
    minWidth: 150,
  },
  {
    field: 'cantonName',
    headerName: 'Cantón',
    headerAlign: 'center',
    flex: 2,
    minWidth: 130,
    renderCell: params => params.value || '—',
  },
  {
    field: 'isPrimary',
    headerName: 'Principal',
    headerAlign: 'center',
    align: 'center',
    flex: 1,
    minWidth: 100,
    renderCell: params =>
      params.value ? (
        <Chip label="Principal" color="primary" size="small" icon={<StarIcon />} />
      ) : (
        <Chip label="No" size="small" variant="outlined" />
      ),
  },
  ...permissionColumns,
  {
    field: 'actions',
    headerName: 'Acciones',
    headerAlign: 'center',
    align: 'center',
    type: 'actions',
    flex: 1.5,
    minWidth: 150,
    renderCell: params => (
      <React.Fragment>
        {!params.row.isPrimary && (
          <Tooltip title="Marcar como principal">
            <IconButton
              size="small"
              color="primary"
              onClick={() => onSetPrimary(params.row)}
            >
              <StarBorderIcon fontSize="small" />
            </IconButton>
          </Tooltip>
        )}
        <Tooltip title={EDIT_PERMISSIONS_TOOLTIPS[params.row.accessMode]}>
          <span>
            <IconButton
              size="small"
              color="primary"
              disabled={params.row.accessMode !== ASSIGNMENT_ACCESS_MODE.FLAGS}
              onClick={() => onEditPermissions(params.row)}
            >
              <TuneOutlinedIcon fontSize="small" />
            </IconButton>
          </span>
        </Tooltip>
        <Tooltip title="Eliminar asignación">
          <IconButton
            size="small"
            color="error"
            onClick={() => onDelete(params.row)}
          >
            <DeleteOutlineIcon fontSize="small" />
          </IconButton>
        </Tooltip>
      </React.Fragment>
    ),
  },
]
